/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Form, Input, Card, notification, Typography, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../components/common/Loader';
import PageContentHeader from '../../../components/common/PageContentHeader';
import {
  addTerritoryService,
  getStateService,
  getTerritoryServiceById,
  updateTerritoryService,
} from '../../../services/master-services';
import { API_RESPONSE_CODES } from '../../../utills/constant';
import InputSelect from '../../../components/common/InputSelect';

const { Title } = Typography;

/**
 * handleSubmit function handles the form submission.
 * It sends the form data to the server and handles the response.
 * @param {Object} values - Form values
 */

const AddTerritory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { pathname } = location;
  const { id } = useParams();

  const [stateData, setStateData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [territoryData, setTerritoryData] = useState();

  //Use effect to get state master data
  useEffect(() => {
    if (pathname.includes('edit')) {
      setEditMode(true);
      getTerritoryById(id);
    }
    getStateData();
  }, []);

  const getTerritoryById = async (id) => {
    try {
      setIsLoading(true);
      const response = await getTerritoryServiceById(id);
      if (response.status === API_RESPONSE_CODES.OK) {
        setIsLoading(false);
        setTerritoryData(response?.data?.data);
        form.setFieldsValue({
          state_id: response?.data?.data?.state_id,
          name: response?.data?.data?.name,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    }
  };

  //function to get state master data
  const getStateData = async () => {
    setIsLoading(true);
    try {
      const stateData = await getStateService();
      setStateData(stateData?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  //function to handle submit
  const handleSubmit = async (values) => {
    const status = editMode ? territoryData?.status : 1;
    values.status = status;
    const service = editMode ? updateTerritoryService(id, values) : addTerritoryService(values);
    try {
      setIsLoading(true);
      const response = await service;
      if (response.data.status === API_RESPONSE_CODES.OK || response.data.status === API_RESPONSE_CODES.CREATED) {
        notification.success({
          message: response?.data?.message,
        });
        navigate('/admin/masters/territory');
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className='user-data'>
        {/* Loader component to show loading spinner */}
        <Loader loading={isLoading} />

        {/* Page header */}
        <PageContentHeader title={editMode ? 'Edit Territory' : 'Add Territory'} />

        <div className='personal-detail'>
          <Card>
            <div className='user-left d-flex align-items-center'>
              <Title level={4} className='pe-2 pb-2'>
                Territory Details
              </Title>
            </div>
            <Form
              layout='vertical'
              name='add-user-form'
              initialValues={{
                remember: true,
              }}
              form={form}
              onFinish={handleSubmit}
            >
              <div className='detail-wrapper'>
                <Row gutter={20} justify='start'>
                  {/* State Filter */}
                  <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                    <InputSelect
                      allowClear={false}
                      label='State'
                      name='state_id'
                      options={stateData}
                      placeholder='State'
                      optionName={'name'}
                      className='form-control-ant'
                      rules={[
                        {
                          required: true,
                          message: 'Please select your state',
                        },
                      ]}
                    />
                  </Col>

                  {/* Territory Input Filter */}
                  <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                    <div className='login-input-field'>
                      <Form.Item
                        name='name'
                        label='Territory'
                        rules={[
                          {
                            required: true,
                            message: '',
                          },
                          () => ({
                            validator(_, value) {
                              if (!value) {
                                return Promise.reject('Please input your territory');
                              }

                              if (/\s{2,}/.test(value)) {
                                return Promise.reject('Territory cannot contain two consecutive spaces');
                              }
                              const trimmedValue = value.trim();
                              if (trimmedValue !== value) {
                                return Promise.reject('Territory cannot start or end with spaces');
                              }
                              if (value?.length < 3 || value?.length > 30) {
                                return Promise.reject('Territory must be between 3 and 30 characters');
                              }
                              if (!/^[a-zA-Z0-9\s()]+$/.test(value)) {
                                return Promise.reject('Territory can only contain alphanumeric characters');
                              }
                              // Check if the string is numeric only
                              if (/^[\d()]+$/.test(value)) {
                                return Promise.reject('Territory cannot be only numeric values');
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input type='text' placeholder='Territory' className='form-control-ant' />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className='user-right d-flex align-items-center justify-content-end mt-3'>
                <Space size='middle'>
                  {/* Cancel button */}
                  <Button
                    type='primary'
                    ghost
                    danger
                    className='primary-button'
                    onClick={() => navigate('/admin/masters/territory')}
                  >
                    Cancel
                  </Button>
                  {/* Save button */}
                  <Button type='primary' className='secondary-button' htmlType='submit'>
                    {editMode ? 'Update' : 'Save'}
                  </Button>
                </Space>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddTerritory;
